/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { MktuClassShort } from './MktuClassShort'
import {
  MktuClassShortFromJSON,
  MktuClassShortFromJSONTyped,
  MktuClassShortToJSON,
} from './MktuClassShort'
import type { RegistryApplicationImage } from './RegistryApplicationImage'
import {
  RegistryApplicationImageFromJSON,
  RegistryApplicationImageFromJSONTyped,
  RegistryApplicationImageToJSON,
} from './RegistryApplicationImage'
import type { RegistryApplicationCounts } from './RegistryApplicationCounts'
import {
  RegistryApplicationCountsFromJSON,
  RegistryApplicationCountsFromJSONTyped,
  RegistryApplicationCountsToJSON,
} from './RegistryApplicationCounts'
import type { RegistryDates } from './RegistryDates'
import {
  RegistryDatesFromJSON,
  RegistryDatesFromJSONTyped,
  RegistryDatesToJSON,
} from './RegistryDates'

/**
 *
 * @export
 * @interface RegistryShort
 */
export interface RegistryShort {
  /**
   *
   * @type {RegistryApplicationImage}
   * @memberof RegistryShort
   */
  image?: RegistryApplicationImage
  /**
   *
   * @type {RegistryApplicationCounts}
   * @memberof RegistryShort
   */
  counts?: RegistryApplicationCounts
  /**
   *
   * @type {string}
   * @memberof RegistryShort
   */
  registrationNumber: string
  /**
   *
   * @type {string}
   * @memberof RegistryShort
   */
  rightholderName: string
  /**
   *
   * @type {string}
   * @memberof RegistryShort
   */
  rightholderAddress?: string
  /**
   *
   * @type {string}
   * @memberof RegistryShort
   */
  unprotectedElements?: string
  /**
   *
   * @type {string}
   * @memberof RegistryShort
   */
  registrationOfficeCode: string
  /**
   *
   * @type {string}
   * @memberof RegistryShort
   */
  colorInfo?: string
  /**
   *
   * @type {Array<MktuClassShort>}
   * @memberof RegistryShort
   */
  mktuClasses: Array<MktuClassShort>
  /**
   *
   * @type {RegistryDates}
   * @memberof RegistryShort
   */
  dates: RegistryDates
  /**
   *
   * @type {string}
   * @memberof RegistryShort
   */
  registrationSourceLink: string
  /**
   *
   * @type {string}
   * @memberof RegistryShort
   */
  applicationSourceLink: string
}

/**
 * Check if a given object implements the RegistryShort interface.
 */
export function instanceOfRegistryShort(value: object): value is RegistryShort {
  if (
    !('registrationNumber' in value) ||
    value['registrationNumber'] === undefined
  )
    return false
  if (!('rightholderName' in value) || value['rightholderName'] === undefined)
    return false
  if (
    !('registrationOfficeCode' in value) ||
    value['registrationOfficeCode'] === undefined
  )
    return false
  if (!('mktuClasses' in value) || value['mktuClasses'] === undefined)
    return false
  if (!('dates' in value) || value['dates'] === undefined) return false
  if (
    !('registrationSourceLink' in value) ||
    value['registrationSourceLink'] === undefined
  )
    return false
  if (
    !('applicationSourceLink' in value) ||
    value['applicationSourceLink'] === undefined
  )
    return false
  return true
}

export function RegistryShortFromJSON(json: any): RegistryShort {
  return RegistryShortFromJSONTyped(json, false)
}

export function RegistryShortFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): RegistryShort {
  if (json == null) {
    return json
  }
  return {
    image:
      json['image'] == null
        ? undefined
        : RegistryApplicationImageFromJSON(json['image']),
    counts:
      json['counts'] == null
        ? undefined
        : RegistryApplicationCountsFromJSON(json['counts']),
    registrationNumber: json['registrationNumber'],
    rightholderName: json['rightholderName'],
    rightholderAddress:
      json['rightholderAddress'] == null
        ? undefined
        : json['rightholderAddress'],
    unprotectedElements:
      json['unprotectedElements'] == null
        ? undefined
        : json['unprotectedElements'],
    registrationOfficeCode: json['registrationOfficeCode'],
    colorInfo: json['colorInfo'] == null ? undefined : json['colorInfo'],
    mktuClasses: (json['mktuClasses'] as Array<any>).map(
      MktuClassShortFromJSON
    ),
    dates: RegistryDatesFromJSON(json['dates']),
    registrationSourceLink: json['registrationSourceLink'],
    applicationSourceLink: json['applicationSourceLink'],
  }
}

export function RegistryShortToJSON(value?: RegistryShort | null): any {
  if (value == null) {
    return value
  }
  return {
    image: RegistryApplicationImageToJSON(value['image']),
    counts: RegistryApplicationCountsToJSON(value['counts']),
    registrationNumber: value['registrationNumber'],
    rightholderName: value['rightholderName'],
    rightholderAddress: value['rightholderAddress'],
    unprotectedElements: value['unprotectedElements'],
    registrationOfficeCode: value['registrationOfficeCode'],
    colorInfo: value['colorInfo'],
    mktuClasses: (value['mktuClasses'] as Array<any>).map(MktuClassShortToJSON),
    dates: RegistryDatesToJSON(value['dates']),
    registrationSourceLink: value['registrationSourceLink'],
    applicationSourceLink: value['applicationSourceLink'],
  }
}
